import { lodash } from '@app/common/utils/lang';
import { Time, TimeInstance } from '@app/common/utils/time';

export function formatDecimal(
  value: number,
  fractionDigits: number | null = null,
  minimumFractionDigits: number | null = null,
) {
  if (lodash.isNil(value)) return '';

  if (fractionDigits === null) {
    fractionDigits = 2;
  }

  if (minimumFractionDigits === null) {
    minimumFractionDigits = fractionDigits;
  }

  return new Intl.NumberFormat('en', {
    style: 'decimal',
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
}

export function formatCurrency(value: number) {
  const fractionDigits = value === 0 ? 0 : 2;

  if (window.Intl) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });

    return formatter.format(value);
  }

  return '$' + lodash.round(value);
}

export function formatTime(
  date: TimeInstance | number | string | null | undefined,
  format: 'date' | (string & {}),
  options?: { utc?: boolean; epoch?: boolean; format?: string },
) {
  if (!date) return '';

  const time = lodash.isString(date)
    ? Time.create(date, { utc: options?.utc, format: options?.format })
    : Time.toInstance(date, { utc: options?.utc, epoch: options?.epoch ?? false });

  if (!time.isValid()) return '';

  if (format === 'date') {
    format = 'DD MMMM, YYYY';
  }

  return time.format(format);
}
